import React, { FC } from 'react';
import { PhoneInput as Phone } from 'react-international-phone';
import './phoneInput.css';
import { twMerge } from '@shared/utils/twMerge';
import '../Input/Input.scss';
type PhoneInputProps = {
  value: string;
  onChange: (value: string) => void;
  errors?: string;
  onBlur: Parameters<typeof Phone>[0]['onBlur'];
  classNameError?: string;
  placeholder?: string;
  label?: string;
};
export const PhoneInput: FC<PhoneInputProps> = ({
  value,
  onChange,
  errors,
  onBlur,
  classNameError = '',
  placeholder = '',
  label,
}) => {
  return (
    <div data-testid={'createUserPhoneInput'}>
      <div className={twMerge('flex items-center pb-[1.2rem]')}>
        {label && <span className={twMerge('text-1424 font-semibold')}>{label}</span>}
      </div>
      <Phone
        placeholder={placeholder}
        disableDialCodePrefill
        value={value ?? ''}
        onChange={val => onChange(val)}
        onBlur={onBlur}
        className={twMerge(
          'D7-Input',
          errors &&
            '[&_button]:!border-[#FF400F] [&_button]:bg-[#FFF6F0] [&_input]:!border-[#FF400F] [&_input]:bg-[#FFF6F0]'
        )}
      />
      <span
        data-testid="phone-error-container"
        className={twMerge(
          'ant-input-error text-1420 font-normal',
          errors ? 'visible' : 'invisible',
          classNameError
        )}
      >
        {errors}
      </span>
    </div>
  );
};
